<template>
  <v-stepper-header class="elevation-0">
    <v-stepper-step step="1" :color="color">
      <span v-if="sidebarModules.includes('sidebar-business')">
        {{ `${$t('general.lists')}/${businessModule.p}` }}
      </span>
      <span v-else>{{ $t('general.lists') }}</span>
    </v-stepper-step>

    <v-divider/>

    <v-stepper-step step="2" :color="color">
      {{ $t('general.loadFile') }}
    </v-stepper-step>

    <v-divider/>

    <v-stepper-step step="3" :color="color">
      {{ $t('general.organizeData') }}
    </v-stepper-step>

    <v-divider/>

    <v-stepper-step step="4" :color="color">
      {{ $t('general.verify') }}
    </v-stepper-step>

    <v-divider/>

    <v-stepper-step step="5" :color="color">
      {{ $t('general.assign') }}
    </v-stepper-step>
  </v-stepper-header>
</template>

<script>
export default {
  props: {
    businessModule: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      default: 'kbPink'
    },
    sidebarModules: {
      type: Array,
      required: true
    }
  }
}
</script>
